<template>
  <div class="home" id="home">
    <!-- <Nav /> -->
    <template :key="component?.extraData?.name" v-for="component in mainPages">
      <div :id="component?.extraData?.id">
        <component :is="component?.extraData?.component"></component>
      </div>
    </template>
    <!-- <div id="hero">
      <Hero />
    </div>
    <div>
      <InteractiveMap />
    </div>
    <div id="seatingExperiences">
      <SeatingExperiences />
    </div>
    <div id="campusExperience">
      <CampusExperiences />
    </div> -->
    <Grandstands />
    <!-- <Parking /> -->
  </div>
</template>

<script>
import { computed, onMounted, reactive, watch, toRefs } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { useIntersectionObserver } from "@vueuse/core";
import Hero from "@/pages/Hero.vue";
import InteractiveMap from "@/pages/InteractiveMap";
import SeatingExperiences from "@/pages/SeatingExperiences.vue";
import CampusExperiences from "@/pages/CampusExperiences.vue";
import Grandstands from "@/pages/Grandstands.vue";
import Parking from "@/pages/Parking.vue";
import Nav from "@/components/Nav.vue";

export default {
  name: "home",
  components: {
    Nav,
    Hero,
    InteractiveMap,
    SeatingExperiences,
    CampusExperiences,
    Grandstands,
    Parking,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const state = reactive({
      mainPages: computed(() => store.getters["purl/getPagesMain"]),
    });
    watch(
      () => state.mainPages,
      (mainPages) => {
        if (mainPages) {
          // setTimeout(() => {
          //   var scrollEl = document?.getElementById("home")?.children;
          //   scrollEl.forEach((el) => {
          //     if (el.id)
          //       useIntersectionObserver(
          //         el,
          //         ([{ isIntersecting }], _) => {
          //           if (isIntersecting) {
          //             store.dispatch(`dom/setInviewSection`, el.id);
          //           }
          //         },
          //         { threshold: el.id === "seatingExperiences" ? 0.3 : 0.1 }
          //       );
          //   });
          //   const hash = router.currentRoute.value.hash;
          //   if (hash) {
          //     const hashEl = document.querySelector(hash);
          //     if (hashEl) {
          //       store.dispatch(`dom/setInviewSection`, hash.substring(1));
          //       window.scrollTo({
          //         top: hashEl.offsetTop,
          //         behavior: "smooth",
          //       });
          //     }
          //   }
          // }, 1500);
        }
      }
    );
    return { ...toRefs(state) };
  },
};
</script>

